import { HitApi } from "../Api/ApiHit";
import { searchAdvertisement, searchBooking, searchCart, searchChild, searchFiles, searchGeneralMaster, searchMedia, searchMembership, searchPackage, searchParent, searchProduct, searchRole, searchServices, searchSpecialists, searchStaff, searchUser } from "../constant/Constant";
import { SET_API_JSON, SET_BILL_SUMMARY, SET_BILLIING_STATES__DATA, SET_BILLING__DATA, SET_BILLING_MEMBERSHIP_DATA, SET_BILLING_PACKAGE_DATA, SET_BILLING_PRODUCTS_DATA, SET_BILLING_SERVICES_DATA, SET_CLIENT_INFO, SET_PAYMENT_METHOD__DATA, SET_PAYMENT_METHOD_RESPONSE__DATA, SET_QUESTIONS_DATA, SET_SERVICE_INFO, SET_SURVEY_DATA, SET_SURVEY_RESPONSE_DATA, SET_UNPAID_AMT_DATA } from "../redux/ActionName/ActionName";
import { setDataAction } from "../redux/Actions/SetDataAction";
import { getSelectedUnit } from "../storage/Storage";
import BillSummary from "../WebView/Billing/BillSummary";

export const DoodleBackground = () => {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-[0.03]">
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 400 400"
        className="absolute inset-0 w-full h-full"
        style={{ transform: 'scale(1.5)' }}
      >
        <defs>
          <pattern
            id="doodle-pattern"
            x="0"
            y="0"
            width="400"
            height="400"
            patternUnits="userSpaceOnUse"
          >
            {/* WhatsApp-style doodles */}

            {/* Chat bubbles */}
            <circle cx="50" cy="50" r="15" fill="none" stroke="currentColor" strokeWidth="1.5" />
            <circle cx="65" cy="45" r="8" fill="none" stroke="currentColor" strokeWidth="1" />
            <path d="M35 65 Q45 55 55 65" fill="none" stroke="currentColor" strokeWidth="1" />

            {/* Message lines */}
            <line x1="20" y1="90" x2="80" y2="90" stroke="currentColor" strokeWidth="1" />
            <line x1="25" y1="100" x2="70" y2="100" stroke="currentColor" strokeWidth="1" />
            <line x1="30" y1="110" x2="75" y2="110" stroke="currentColor" strokeWidth="1" />

            {/* Hearts */}
            <path d="M150 40 C140 30, 120 30, 120 50 C120 30, 100 30, 90 40 C90 55, 120 80, 120 80 C120 80, 150 55, 150 40 Z" fill="none" stroke="currentColor" strokeWidth="1" />

            {/* Stars */}
            <path d="M200 60 L205 70 L215 70 L207 77 L210 87 L200 82 L190 87 L193 77 L185 70 L195 70 Z" fill="none" stroke="currentColor" strokeWidth="1" />
            <path d="M320 40 L322 45 L327 45 L323 48 L325 53 L320 50 L315 53 L317 48 L313 45 L318 45 Z" fill="none" stroke="currentColor" strokeWidth="1" />

            {/* Smiley faces */}
            <circle cx="280" cy="90" r="12" fill="none" stroke="currentColor" strokeWidth="1" />
            <circle cx="275" cy="87" r="1.5" fill="currentColor" />
            <circle cx="285" cy="87" r="1.5" fill="currentColor" />
            <path d="M273 95 Q280 100 287 95" fill="none" stroke="currentColor" strokeWidth="1" />

            {/* Phone/device icons */}
            <rect x="40" y="150" width="20" height="30" rx="3" fill="none" stroke="currentColor" strokeWidth="1" />
            <line x1="45" y1="155" x2="55" y2="155" stroke="currentColor" strokeWidth="1" />
            <circle cx="50" cy="172" r="2" fill="none" stroke="currentColor" strokeWidth="1" />

            {/* Coffee cup */}
            <path d="M120 160 L120 180 Q120 185 125 185 L140 185 Q145 185 145 180 L145 160" fill="none" stroke="currentColor" strokeWidth="1" />
            <path d="M145 165 Q155 165 155 170 Q155 175 145 175" fill="none" stroke="currentColor" strokeWidth="1" />
            <line x1="125" y1="155" x2="140" y2="155" stroke="currentColor" strokeWidth="1" />

            {/* Music notes */}
            <circle cx="200" cy="170" r="3" fill="currentColor" />
            <line x1="203" y1="170" x2="203" y2="155" stroke="currentColor" strokeWidth="1.5" />
            <path d="M203 155 Q208 153 213 155 L213 165" fill="none" stroke="currentColor" strokeWidth="1" />

            {/* Flower */}
            <circle cx="300" cy="160" r="4" fill="none" stroke="currentColor" strokeWidth="1" />
            <circle cx="295" cy="155" r="3" fill="none" stroke="currentColor" strokeWidth="1" />
            <circle cx="305" cy="155" r="3" fill="none" stroke="currentColor" strokeWidth="1" />
            <circle cx="295" cy="165" r="3" fill="none" stroke="currentColor" strokeWidth="1" />
            <circle cx="305" cy="165" r="3" fill="none" stroke="currentColor" strokeWidth="1" />
            <circle cx="300" cy="160" r="1.5" fill="currentColor" />

            {/* Speech bubbles */}
            <ellipse cx="80" cy="250" rx="25" ry="15" fill="none" stroke="currentColor" strokeWidth="1" />
            <path d="M65 260 Q55 265 60 270" fill="none" stroke="currentColor" strokeWidth="1" />

            {/* Lightning bolt */}
            <path d="M180 240 L170 260 L175 260 L165 280 L175 260 L170 260 Z" fill="none" stroke="currentColor" strokeWidth="1" />

            {/* Airplane */}
            <path d="M250 240 L270 245 L275 250 L270 245 L280 250 L270 245 L250 240 L255 250 L250 240" fill="none" stroke="currentColor" strokeWidth="1" />

            {/* Clock */}
            <circle cx="320" cy="250" r="12" fill="none" stroke="currentColor" strokeWidth="1" />
            <line x1="320" y1="250" x2="320" y2="242" stroke="currentColor" strokeWidth="1" />
            <line x1="320" y1="250" x2="325" y2="255" stroke="currentColor" strokeWidth="1" />

            {/* Geometric shapes */}
            <polygon points="50,320 65,340 35,340" fill="none" stroke="currentColor" strokeWidth="1" />
            <rect x="120" y="320" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="1" />
            <circle cx="200" cy="330" r="10" fill="none" stroke="currentColor" strokeWidth="1" />

            {/* Arrows */}
            <path d="M250 320 L270 320 M265 315 L270 320 L265 325" fill="none" stroke="currentColor" strokeWidth="1" />
            <path d="M320 315 L320 335 M315 330 L320 335 L325 330" fill="none" stroke="currentColor" strokeWidth="1" />

            {/* Additional scattered elements */}
            <circle cx="350" cy="120" r="2" fill="currentColor" />
            <circle cx="380" cy="180" r="1.5" fill="currentColor" />
            <circle cx="30" cy="300" r="2" fill="currentColor" />
            <circle cx="100" cy="380" r="1.5" fill="currentColor" />

            {/* Wavy lines */}
            <path d="M350 200 Q360 195 370 200 Q380 205 390 200" fill="none" stroke="currentColor" strokeWidth="1" />
            <path d="M20 380 Q30 375 40 380 Q50 385 60 380" fill="none" stroke="currentColor" strokeWidth="1" />

          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#doodle-pattern)" />
      </svg>

      {/* Additional floating doodles for variety */}
      <div className="absolute top-[10%] left-[15%] transform rotate-12">
        <svg width="30" height="30" viewBox="0 0 30 30">
          <path d="M15 5 L20 15 L15 25 L10 15 Z" fill="none" stroke="currentColor" strokeWidth="1" opacity="0.3" />
        </svg>
      </div>

      <div className="absolute top-[60%] right-[20%] transform -rotate-45">
        <svg width="25" height="25" viewBox="0 0 25 25">
          <circle cx="12.5" cy="12.5" r="8" fill="none" stroke="currentColor" strokeWidth="1" opacity="0.2" />
          <path d="M8 12.5 Q12.5 8 17 12.5 Q12.5 17 8 12.5" fill="none" stroke="currentColor" strokeWidth="1" opacity="0.3" />
        </svg>
      </div>

      <div className="absolute bottom-[20%] left-[70%] transform rotate-30">
        <svg width="35" height="35" viewBox="0 0 35 35">
          <path d="M10 25 Q17.5 10 25 25" fill="none" stroke="currentColor" strokeWidth="1" opacity="0.25" />
          <circle cx="17.5" cy="15" r="3" fill="none" stroke="currentColor" strokeWidth="1" opacity="0.3" />
        </svg>
      </div>
    </div>
  );
};


export const colorThemes = {
  rose: {
    name: 'Rose Pink',
    bg: 'from-rose-50 via-pink-50 to-rose-100',
    primary: 'from-rose-600 to-pink-700',
    accent: 'rose-600',
    hover: 'hover:bg-rose-100',
    focus: 'focus:ring-rose-500 focus:border-rose-500',
    button: 'bg-rose-600 hover:bg-rose-700',
    quickAction: 'bg-rose-100/70 hover:bg-rose-200 text-rose-700 border-rose-200/50',
    userBubble: 'bg-rose-600',
    userText: 'text-rose-100'
  },
  amber: {
    name: 'Warm Amber',
    bg: 'from-amber-50 via-yellow-50 to-orange-50',
    primary: 'from-amber-600 to-orange-700',
    accent: 'amber-600',
    hover: 'hover:bg-amber-100',
    focus: 'focus:ring-amber-500 focus:border-amber-500',
    button: 'bg-amber-600 hover:bg-amber-700',
    quickAction: 'bg-amber-100/70 hover:bg-amber-200 text-amber-700 border-amber-200/50',
    userBubble: 'bg-amber-600',
    userText: 'text-amber-100'
  },
  lightBlue: {
    name: 'Light Blue',
    bg: 'from-sky-50 via-blue-50 to-cyan-50',
    primary: 'from-sky-600 to-blue-700',
    accent: 'sky-600',
    hover: 'hover:bg-sky-100',
    focus: 'focus:ring-sky-500 focus:border-sky-500',
    button: 'bg-sky-600 hover:bg-sky-700',
    quickAction: 'bg-sky-100/70 hover:bg-sky-200 text-sky-700 border-sky-200/50',
    userBubble: 'bg-sky-600',
    userText: 'text-sky-100'
  },
  blue: {
    name: 'Ocean Blue',
    bg: 'from-blue-50 via-indigo-50 to-blue-100',
    primary: 'from-blue-600 to-indigo-700',
    accent: 'blue-600',
    hover: 'hover:bg-blue-100',
    focus: 'focus:ring-blue-500 focus:border-blue-500',
    button: 'bg-blue-600 hover:bg-blue-700',
    quickAction: 'bg-blue-100/70 hover:bg-blue-200 text-blue-700 border-blue-200/50',
    userBubble: 'bg-blue-600',
    userText: 'text-blue-100'
  }
};




export const transformProductIds = (productIds, status) => {
  return productIds.map(id => ({
    productId: id,
    qty: 0,
    status: status,
    stockIn: 0,
    stockOut: 0,
    unitIds: getSelectedUnit()?._id,
    inventoryBill: ''
  }));
};



export function isObjectEmpty(obj) {
  return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
}


export function markDeliveryStatus(steps) {
  return steps.map(item => {
    const hasProduct = item.product !== undefined && item.product !== null && item.product.trim() !== "";
    const hasBrand = item.brand !== undefined && item.brand !== null && item.brand.trim() !== "";

    return {
      ...item,
      isDelivered: hasProduct && hasBrand
    };
  });
}

// Generate a comprehensive device fingerprint (IMEI alternative)
const generateDeviceFingerprint = () => {
  try {
    // Create canvas fingerprint
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    ctx.textBaseline = 'top';
    ctx.font = '14px Arial';
    ctx.fillText('Device fingerprint', 2, 2);

    // Collect various device characteristics
    const fingerprint = [
      navigator.userAgent,
      navigator.language,
      navigator.platform,
      window.screen.width + 'x' + window.screen.height,
      window.screen.colorDepth,
      new Date().getTimezoneOffset(),
      navigator.hardwareConcurrency || 'unknown',
      navigator.deviceMemory || 'unknown',
      canvas.toDataURL().slice(-50) // Last 50 chars of canvas fingerprint
    ].join('|');

    // Create a hash-like identifier
    let hash = 0;
    for (let i = 0; i < fingerprint.length; i++) {
      const char = fingerprint.charCodeAt(i);
      hash = ((hash << 5) - hash) + char;
      hash = hash & hash; // Convert to 32-bit integer
    }

    // Convert to positive number and create device ID
    const deviceId = 'DEV_' + Math.abs(hash).toString(16).toUpperCase();
    return deviceId;
  } catch (error) {
    // Fallback to simpler method
    return 'DEV_' + Date.now().toString(36).toUpperCase() + Math.random().toString(36).substr(2).toUpperCase();
  }
};

// Get hardware information
const getHardwareInfo = () => {
  return {
    cores: navigator.hardwareConcurrency || 'unknown',
    memory: navigator.deviceMemory || 'unknown',
    screen: `${window.screen.width}x${window.screen.height}`,
    colorDepth: window.screen.colorDepth,
    pixelRatio: window.devicePixelRatio || 1,
    availableScreenSize: `${window.screen.availWidth}x${window.screen.availHeight}`
  };
};

// Get browser capabilities fingerprint
const getBrowserCapabilities = () => {
  return {
    webGL: !!window.WebGLRenderingContext,
    touchSupport: 'ontouchstart' in window,
    cookieEnabled: navigator.cookieEnabled,
    localStorage: !!window.localStorage,
    sessionStorage: !!window.sessionStorage,
    indexedDB: !!window.indexedDB,
    webWorkers: !!window.Worker,
    serviceWorker: 'serviceWorker' in navigator
  };
};

export const getDeviceInfo = () => {
  // Generate a comprehensive device fingerprint (IMEI alternative)
  const deviceFingerprint = generateDeviceFingerprint();

  const deviceInfo = [{
    userAgent: navigator.userAgent,
    platform: navigator.platform,
    language: navigator.language,
    cookieEnabled: navigator.cookieEnabled,
    onLine: navigator.onLine,
    screenWidth: window.screen.width,
    screenHeight: window.screen.height,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    timestamp: new Date().toISOString(),
    // Additional useful device information
    browser: getBrowserInfo(),
    deviceType: getDeviceType(),
    operatingSystem: getOperatingSystem(),
    // Enhanced device identification (replaces MAC address/IMEI)
    deviceFingerprint: deviceFingerprint,
    deviceId: deviceFingerprint, // Use this as primary device identifier
    deviceMacAddress: deviceFingerprint, // Keep same field name for backend compatibility
    // Hardware characteristics
    hardwareInfo: getHardwareInfo(),
    // Browser capabilities fingerprint
    browserCapabilities: getBrowserCapabilities()
  }];

  return deviceInfo;
};
const getBrowserInfo = () => {
  const userAgent = navigator.userAgent;

  if (userAgent.includes('Chrome') && !userAgent.includes('Edg')) {
    return 'Chrome';
  } else if (userAgent.includes('Firefox')) {
    return 'Firefox';
  } else if (userAgent.includes('Safari') && !userAgent.includes('Chrome')) {
    return 'Safari';
  } else if (userAgent.includes('Edg')) {
    return 'Edge';
  } else if (userAgent.includes('Opera') || userAgent.includes('OPR')) {
    return 'Opera';
  } else {
    return 'Unknown';
  }
};
const getDeviceType = () => {
  const userAgent = navigator.userAgent;

  if (/tablet|ipad|playbook|silk/i.test(userAgent)) {
    return 'Tablet';
  } else if (/mobile|iphone|ipod|android|blackberry|opera|mini|windows\sce|palm|smartphone|iemobile/i.test(userAgent)) {
    return 'Mobile';
  } else {
    return 'Desktop';
  }
};
const getOperatingSystem = () => {
  const userAgent = navigator.userAgent;
  const platform = navigator.platform;

  if (/Win/.test(platform)) {
    return 'Windows';
  } else if (/Mac/.test(platform)) {
    return 'macOS';
  } else if (/Linux/.test(platform)) {
    return 'Linux';
  } else if (/iPhone|iPad|iPod/.test(userAgent)) {
    return 'iOS';
  } else if (/Android/.test(userAgent)) {
    return 'Android';
  } else {
    return 'Unknown';
  }
};


export const searchGeneralMasterData = async (usedBy, searchValue = "", limit = 500, page = 1) => {
  try {
    const json = {
      page,
      limit,
      search: {
        usedBy,
        // value: searchValue
      }
    };


    const response = await HitApi(json, searchGeneralMaster);

    console.log(`${usedBy} master response:`, response);

    if (response?.data?.docs?.length) {
      const options = response.data.docs?.map((item) => ({
        label: item.label,
        value: item.value,
        // Include any additional fields that might be useful
        ...(item.description && { description: item.description }),
        ...(item.code && { code: item.code }),
        ...(item.category && { category: item.category })
      }));

      return {
        success: true,
        data: options,
        total: response.total || response.data.length,
        page: response.page || page,
        hasMore: response.hasMore || false
      };
    } else {
      return {
        success: true,
        data: [],
        total: 0,
        page,
        hasMore: false
      };
    }
  } catch (error) {
    console.error(`Error fetching ${usedBy} from master:`, error);
    return {
      success: false,
      data: [],
      error: error.message || 'Failed to fetch data',
      total: 0,
      page,
      hasMore: false
    };
  }
};



// Helper function to check if a field has an error
export const hasError = (fieldName, ApiReducer) => {
  return ApiReducer.apiJsonError && ApiReducer.apiJsonError[fieldName];
};

// Helper function to get error message
export const getErrorMsg = (fieldName, ApiReducer) => {
  return ApiReducer.apiJsonError ? ApiReducer.apiJsonError[fieldName] : "";
};


export const getCategoryDisplayName = (value) => {
  const displayNames = {
    'dashboard': "Dashboard",
    'user': 'User Management',
    "staff": "Staff Dashboard",
    'unit': 'Unit Management',
    'client': 'Client Management',
    'seat': 'Seat Management',
    'vendor': 'Vendor Management',
    'attendance': 'Attendance Management',
    'inventory': 'Inventory Management',
    'dashboard': 'Dashboard',
    'product': 'Product Management',
    'membership': 'Membership Management',
    'services': 'Services',
    'parent': 'Parent Services',
    'child': 'Child Services',
    'floor': 'Floor Management',
    "task": "Task Managemen",
    "ngb": "NGB",
  };
  return displayNames[value.toLowerCase()] || value.charAt(0).toUpperCase() + value.slice(1);
};


export const getButtonProps = (categoryValue, permissionType, originalAllowed, index, childIndex = null, selectedPermissions) => {
  const key = childIndex !== null ? `${categoryValue}_${childIndex}_${permissionType}` : `${categoryValue}_${permissionType}`;
  const isSelected = selectedPermissions[key];

  const readKey = childIndex !== null ? `${categoryValue}_${childIndex}_read` : `${categoryValue}_read`;
  const writeKey = childIndex !== null ? `${categoryValue}_${childIndex}_write` : `${categoryValue}_write`;

  const isReadSelected = selectedPermissions[readKey];
  const isWriteSelected = selectedPermissions[writeKey];

  let isDisabled = false;

  if (childIndex !== null) {
    const parentReadKey = `${categoryValue}_read`;
    const parentWriteKey = `${categoryValue}_write`;
    const parentDeleteKey = `${categoryValue}_delete`;

    const isParentReadSelected = selectedPermissions[parentReadKey];
    const isParentWriteSelected = selectedPermissions[parentWriteKey];
    const isParentDeleteSelected = selectedPermissions[parentDeleteKey];

    if (permissionType === 'read' && !isParentReadSelected) isDisabled = true;
    if (permissionType === 'write' && (!isParentWriteSelected || !isReadSelected)) isDisabled = true;
    if (permissionType === 'delete' && (!isParentDeleteSelected || !isReadSelected || !isWriteSelected)) isDisabled = true;
  } else {
    if (permissionType === 'write' && !isReadSelected) isDisabled = true;
    if (permissionType === 'delete' && (!isReadSelected || !isWriteSelected)) isDisabled = true;
  }

  // Also disable during submission
  isDisabled = isDisabled;

  const baseClasses = isDisabled
    ? 'opacity-50 cursor-not-allowed bg-gray-100 text-gray-400 border-gray-200 px-4 py-2 font-medium'
    : 'px-4 py-2 font-medium transition-all duration-200';

  if (isDisabled) return { className: baseClasses, variant: 'outline', disabled: true };

  const colors = {
    read: isSelected ? 'bg-amber-500 hover:bg-amber-600 text-white border-amber-500 shadow-sm' : originalAllowed ? 'bg-amber-50 hover:bg-amber-100 text-amber-700 border-amber-200' : '',
    write: isSelected ? 'bg-emerald-500 hover:bg-emerald-600 text-white border-emerald-500 shadow-sm' : originalAllowed ? 'bg-emerald-50 hover:bg-emerald-100 text-emerald-700 border-emerald-200' : '',
    delete: isSelected ? 'bg-rose-500 hover:bg-rose-600 text-white border-rose-500 shadow-sm' : originalAllowed ? 'bg-rose-50 hover:bg-rose-100 text-rose-700 border-rose-200' : ''
  };

  return {
    className: `${baseClasses} ${colors[permissionType] || 'bg-gray-50 hover:bg-gray-100 text-gray-600 border-gray-200'}`,
    variant: isSelected ? 'solid' : 'outline'
  };
};



export function falseAllPermissions(data) {
  return data.map((item) => ({
    ...item,
    permission: item.permission.map((perm) => ({
      ...perm,
      read: false,
      write: false,
      delete: false,
    })),
    child: item.child?.map((childItem) => ({
      ...childItem,
      permission: childItem.permission.map((perm) => ({
        ...perm,
        read: false,
        write: false,
        delete: false,
      })),
    })) || [],
  }));
}



export const constructFinalJson = async (permissionsData) => {
  return new Promise((resolve) => {
    const allowedEndPoints = [];
    const permission = [];

    permissionsData?.forEach(item => {
      const permissionItem = { value: item.value, permission: [], child: [] };

      // Process parent permissions
      if (item.permission?.length > 0) {
        item.permission.forEach(perm => {
          if (perm.read?.allowed && perm.read?.url) allowedEndPoints.push(...perm.read.url);
          if (perm.write?.allowed && perm.write?.url) allowedEndPoints.push(...perm.write.url);
          if (perm.delete?.allowed && perm.delete?.url) allowedEndPoints.push(...perm.delete.url);

          permissionItem.permission.push({
            read: perm.read?.allowed || false,
            write: perm.write?.allowed || false,
            delete: perm.delete?.allowed || false
          });
        });
      }

      // Process child permissions
      if (item.child?.length > 0) {
        item.child.forEach(childItem => {
          const childPermissionItem = { value: childItem.value, permission: [] };

          if (childItem.permission?.length > 0) {
            childItem.permission.forEach(childPerm => {
              if (childPerm.read?.allowed && childPerm.read?.url) allowedEndPoints.push(...childPerm.read.url);
              if (childPerm.write?.allowed && childPerm.write?.url) allowedEndPoints.push(...childPerm.write.url);
              if (childPerm.delete?.allowed && childPerm.delete?.url) allowedEndPoints.push(...childPerm.delete.url);

              childPermissionItem.permission.push({
                read: childPerm.read?.allowed || false,
                write: childPerm.write?.allowed || false,
                delete: childPerm.delete?.allowed || false
              });
            });
          }
          permissionItem.child.push(childPermissionItem);
        });
      }
      permission.push(permissionItem);
    });

    resolve({
      allowedEndPoints: [...new Set(allowedEndPoints)],
      permission: permission
    });
  });
};



export function addIsDeliveredProductKey(data) {
  if (!data?.steps || !Array.isArray(data.steps)) return data;

  data.steps.forEach((step) => {
    if (Array.isArray(step.products) && step.products.length > 0) {
      step.products = step.products.map((product) => {
        const hasValidProduct = product.product && product.brand;
        return {
          ...product,
          isDeliverdProduct: hasValidProduct ? true : false,
        };
      });
    }
  });

  return data;
}



export function transformServiceData(data) {
  return data.map(item => ({
    serviceData: item.serviceData,
    quantity: 1,
    price: item.serviceData?.price,
    total: item.serviceData?.price || 0,
    staffData: item.staffData
  }));
}




export const calculateBillSummary = (billingReducer, dispatch, workOnAdjustPayment) => {
  console.log("Recalculating bill summary...", billingReducer);

  let SubTotal = 0;

  billingReducer?.selectedServices?.forEach((ele) => {
    SubTotal += Number(ele?.total) || 0;
  });

  billingReducer?.selectedProducts?.forEach((ele) => {
    SubTotal += Number(ele?.total) || 0;
  });

  billingReducer?.selectedMemberships?.forEach((ele) => {
    SubTotal += Number(ele?.total) || 0;
  });

  billingReducer?.selectedPackages?.forEach((ele) => {
    SubTotal += Number(ele?.total) || 0;
  });

  const extraCharge = Number(billingReducer?.billSummary?.extraCharges) || 0;

  const discountType = billingReducer?.billSummary?.discountType || 'percentage';
  const discountValue = Number(billingReducer?.billSummary?.discountValue) || 0;

  let discount = 0;
  if (discountType === 'percentage') {
    const validDiscount = discountValue >= 100 ? 100 : discountValue;
    discount = ((SubTotal + extraCharge) * validDiscount) / 100;
  } else {
    discount = discountValue;
  }

  const taxAbleAmount = SubTotal + extraCharge - discount;

  // discount = Math.min(discount, taxAbleAmount);

  const gstPercentage = Number(billingReducer?.billSummary?.gstPercentage) || 0;

  const couponCode = billingReducer?.billSummary?.couponCode

  const gst = (taxAbleAmount * gstPercentage) / 100;

  const grandTotal = taxAbleAmount + gst;
  console.log("taxAbleAmount", taxAbleAmount, "gst", gst, "discount", discount);


  const payingNow = Math.round(
    billingReducer?.paymentMethod?.reduce((sum, item) => sum + (item.price || 0), 0) || 0
  );

  const roundedSubTotal = Math.round(SubTotal);
  const Discount = Math.round(discount);
  const TaxableAmount = Math.round(taxAbleAmount);
  const Gst = Math.round(gst);
  const balanceAmount = billingReducer?.clientInfo?.unpaidAmt ? billingReducer?.clientInfo?.unpaidAmt : 0
  const GrandTotal = Math.round(grandTotal) + balanceAmount;
  console.log("GrandTotal----", GrandTotal);

  const roundedExtraCharges = Math.round(extraCharge);
  let AdjustPayment;
  if (workOnAdjustPayment) {
    AdjustPayment = billingReducer?.billSummary?.adjustPayment;
  } else {
    AdjustPayment = payingNow === 0 ? GrandTotal : GrandTotal - payingNow;
  }


  const DuePayment = payingNow === 0 ? 0 : GrandTotal - payingNow;

  const billSummary = {
    subTotal: roundedSubTotal,
    discount: Discount,
    discountType: discountType,
    discountValue: Math.round(discountValue),
    taxableAmount: TaxableAmount,
    gstPercentage: Math.round(gstPercentage),
    GST: Gst,
    balanceAmount: balanceAmount,
    grandTotal: GrandTotal,
    extraCharges: roundedExtraCharges,
    adjustPayment: AdjustPayment,
    payingNow: payingNow,
    duePayment: AdjustPayment === 0 ? 0 : DuePayment, //ye me isliye krra hu kyonki payment dene ke baad bhi pichla wala due amount dikh ra tha 
    couponCode: couponCode
  };

  dispatch(setDataAction(billSummary, SET_BILL_SUMMARY));
};



export const allReduxClear = (dispatch) => {

  //survey redux
  dispatch(setDataAction([{}], SET_QUESTIONS_DATA))
  dispatch(setDataAction([], SET_SURVEY_RESPONSE_DATA))
  dispatch(setDataAction(null, SET_SURVEY_DATA))
  dispatch(setDataAction({}, SET_API_JSON))

  //billing redux 
  dispatch(setDataAction(null, SET_BILLING__DATA));
  dispatch(setDataAction(null, SET_CLIENT_INFO));
  dispatch(setDataAction([], SET_SERVICE_INFO));
  dispatch(setDataAction([], SET_BILLING_PRODUCTS_DATA));
  dispatch(setDataAction([], SET_BILLING_MEMBERSHIP_DATA));
  dispatch(setDataAction([], SET_BILLING_PACKAGE_DATA));
  dispatch(setDataAction(null, SET_UNPAID_AMT_DATA))
  dispatch(setDataAction({
    subTotal: 0,
    taxAbleAmount: 0,
    GST: 0,
    gstPercentage: 18,
    grandTotal: 0,
    payingNow: 0,
    dueAmount: 0,
    discount: 0,
    discountType: 'percentage',
    discountValue: 0,
    extraCharges: 0,
    adjustPayment: 0,
    couponCode: null,
    notes: null
  }, SET_BILL_SUMMARY));
  dispatch(setDataAction([], SET_BILLING_SERVICES_DATA));
  dispatch(setDataAction([{ title: "CASH", price: 0 }, { title: "CARD", price: 0 }, { title: "UPI", price: 0 }, { title: "WALLET", price: 0 }], SET_PAYMENT_METHOD__DATA));
};



export function checkStaffData(obj) {
  // Arrays to check
  const keys = ["selectedServices", "selectedMemberships", "selectedProducts"];

  for (let key of keys) {
    if (Array.isArray(obj[key])) {
      for (let item of obj[key]) {
        if (!item.hasOwnProperty("staffData")) {
          return false; // stop immediately if staffData missing
        }
      }
    }
  }

  return true; // all good
}


export const getNavigationPath = (value) => {
  if (value === "staff") {
    return "/staffdashboard"
  }
  if (value === "client") {
    return "/client"
  }
  if (value === "user") {
    return "/users"
  }
  if (value === "unit") {
    return "/unit"
  }
  if (value === "vendor") {
    return "/vendormanagement"
  }
  if (value === "seat") {
    return "/seat"
  }
  if (value === "product") {
    return "/products"
  }
  if (value === "services") {
    return "/services"
  }
  if (value === "inventory") {
    return "/inbound"
  }
  if (value === "quicksale") {
    return "/quicksale"
  }
  if (value === "bills") {
    return '/bills'
  }
  else return "/"

}


export const transformBillingDataForChart = (apiResponseData, mode = 'Weekly') => {
  if (!apiResponseData || !Array.isArray(apiResponseData)) {
    return [];
  }

  if (mode === 'Monthly') {
    return transformMonthlyData(apiResponseData);
  } else {
    return transformWeeklyData(apiResponseData);
  }
};

const transformMonthlyData = (data) => {
  // Group data by month
  const monthlyRevenue = {};
  const monthNames = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];

  // Initialize all months with 0 revenue
  monthNames.forEach(month => {
    monthlyRevenue[month] = 0;
  });

  // Sum revenue by month
  data.forEach(bill => {
    if (bill.billSummary && bill.billSummary.grandTotal && bill.createdAt) {
      const date = new Date(bill.createdAt);
      const monthName = monthNames[date.getMonth()];
      monthlyRevenue[monthName] += bill.billSummary.grandTotal;
    }
  });

  // Convert to array format for chart
  return monthNames.map(month => ({
    name: month,
    revenue: monthlyRevenue[month]
  })).filter(item => item.revenue > 0); // Only return months with revenue
};

const transformWeeklyData = (data) => {
  // Group data by week of current month
  const weeklyRevenue = {
    'First Week': 0,
    'Second Week': 0,
    'Third Week': 0,
    'Fourth Week': 0,
    'Fifth Week': 0
  };

  data.forEach(bill => {
    if (bill.billSummary && bill.billSummary.grandTotal && bill.createdAt) {
      const date = new Date(bill.createdAt);
      const dayOfMonth = date.getDate();

      // Determine which week of the month
      let weekName;
      if (dayOfMonth <= 7) {
        weekName = 'First Week';
      } else if (dayOfMonth <= 14) {
        weekName = 'Second Week';
      } else if (dayOfMonth <= 21) {
        weekName = 'Third Week';
      } else if (dayOfMonth <= 28) {
        weekName = 'Fourth Week';
      } else {
        weekName = 'Fifth Week';
      }

      weeklyRevenue[weekName] += bill.billSummary.grandTotal;
    }
  });

  // Convert to array format for chart, filter out weeks with no revenue
  return Object.entries(weeklyRevenue)
    .filter(([week, revenue]) => revenue > 0)
    .map(([week, revenue]) => ({
      name: week,
      revenue: revenue
    }));
};



export const perMinuteSalary = (userData) => {
  const monthlySalary = userData.salary;
  const dailyWorkingHours = parseInt(userData.workingHours);

  // 26 working days per month (30 days - 4 Tuesdays off)
  const workingDaysPerMonth = 26;
  const totalWorkingMinutes = workingDaysPerMonth * dailyWorkingHours * 60;

  return monthlySalary / totalWorkingMinutes;
};



export function calculatePaymentTotals(bills) {
  const totals = {};

  bills.forEach((bill) => {
    if (bill.paymentMethod && Array.isArray(bill.paymentMethod)) {
      bill.paymentMethod.forEach((pm) => {
        const key = pm.title.toLowerCase(); // normalize to lowercase
        totals[key] = (totals[key] || 0) + (Number(pm.price) || 0);
      });
    }
  });

  return totals;
}


export function countCustomerTypes(customers) {
  return customers.reduce((acc, customer) => {
    const type = customer.customerType?.toLowerCase() === "walk in" ? "walkIn" : "nonWalkIn";
    acc[type] = (acc[type] || 0) + 1;
    return acc;
  }, {});
}



export function sumPaymentMethods(input) {
  console.log('input', input);

  const result = { CASH: 0, CARD: 0, UPI: 0, WALLET: 0, OTHER: 0 };

  if (!input || !Array.isArray(input.billingData)) return result;

  for (const bill of input.billingData) {
    const methods = Array.isArray(bill.paymentMethod) ? bill.paymentMethod : [];
    for (const m of methods) {
      const title = (m.title || "OTHER").toString().trim().toUpperCase();
      // ensure numeric price (fallback 0)
      const price = Number(m.price) || 0;

      if (title.includes("CASH")) result.CASH += price;
      else if (title.includes("CARD")) result.CARD += price;
      else if (title.includes("UPI")) result.UPI += price;
      else if (title.includes("WALLET")) result.WALLET += price;
      else result.OTHER += price;
    }
  }

  // add grand total
  result.balanceCASH = result.CASH
  result.balanceCARD = result.CARD
  result.balanceUPI = result.UPI
  result.balanceWALLET = result.WALLET
  result.GRAND_TOTAL = result.CASH + result.CARD + result.UPI + result.WALLET + result.OTHER;
  return result;
}

export const getTimestampRange = (period) => {
  const now = new Date();

  const ranges = {
    // Today - Start and end of current day
    today: {
      start: new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0).getTime(),
      end: new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59, 999).getTime()
    },

    // Current week - From Sunday to now
    currentWeek: {
      start: new Date(now.getFullYear(), now.getMonth(), now.getDate() - now.getDay(), 0, 0, 0, 0).getTime(),
      end: now.getTime()
    },

    // Current month - From 1st of month to now
    currentMonth: {
      start: new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0, 0).getTime(),
      end: now.getTime()
    },

    // Hourly - Last hour
    hourly: {
      start: new Date(now.getTime() - (60 * 60 * 1000)).getTime(), // 1 hour ago
      end: now.getTime()
    },

    // Previous 4 months - For monthly chart
    previous4Months: {
      start: new Date(now.getFullYear(), now.getMonth() - 4, 1, 0, 0, 0, 0).getTime(),
      end: new Date(now.getFullYear(), now.getMonth(), 0, 23, 59, 59, 999).getTime()
    },

    // Full current month - Complete month for chart data
    fullCurrentMonth: {
      start: new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0, 0).getTime(),
      end: new Date(now.getFullYear(), now.getMonth() + 1, 0, 23, 59, 59, 999).getTime()
    }
  };

  return ranges[period] || ranges.today;
};



export const calculateRevenue = (data, period) => {
  if (!Array.isArray(data)) return 0;

  const { start, end } = getTimestampRange(period);

  return data.reduce((total, bill) => {
    const billDate = new Date(bill?.createdAt).getTime();
    if (
      bill?.billSummary?.grandTotal &&
      billDate >= start &&
      billDate <= end
    ) {
      return total + bill.billSummary.grandTotal;
    }
    return total;
  }, 0);
};


export const getMethodTotals = (data) => {
  const initial = {
    cash: 0,
    card: 0,
    upi: 0,
    wallet: 0,
  };

  return data.reduce((acc, curr) => {
    const method = curr.method?.toLowerCase(); // normalize case
    const amount = Number(curr.amount) || 0;

    if (acc.hasOwnProperty(method)) {
      acc[method] += amount;
    }

    return acc;
  }, { ...initial });
};




export function formatIntlNumber(num, locale = 'en-IN', options = {}) {
  if (num === null || num === undefined || num === '') return '';

  // Agar string hai toh digits ke alawa sab remove karo
  const cleanNum = String(num).replace(/[^0-9.-]/g, '');

  const parsed = parseFloat(cleanNum);
  if (isNaN(parsed)) return '';

  return new Intl.NumberFormat(locale, options).format(parsed);
}


export function calculateTotals(data) {
  const totals = {};

  data?.forEach(exp => {
    const method = exp.method;

    // Convert to number, but treat invalid or empty strings as 0
    const amount = exp.amount !== undefined && exp.amount !== null && exp.amount !== '' ? parseFloat(exp.amount) : 0;

    // Initialize if not already
    if (!totals[method]) {
      totals[method] = 0;
    }

    totals[method] += amount; // 0 will just add 0, nothing changes
  });

  return totals;
}


export const calculateMissingAmounts = (todayBillData, cardAmountRecived, setMissingCashAmount, setMissingUpiAmount, setMissingWalletAmount, setMissingCardAmount) => {
  const toNumber = (value) => Number(value || 0);

  // --- CASH ---
  const actualCash = toNumber(todayBillData?.cashAmount);
  const balanceCash = toNumber(todayBillData?.balanceCashAmount);
  const totalCashExpense = toNumber(todayBillData?.totalExpense?.CASH);
  const missingCash = actualCash - (balanceCash + totalCashExpense);
  setMissingCashAmount(missingCash);

  // --- UPI ---
  const actualUpi = toNumber(todayBillData?.upiAmount);
  const balanceUpi = toNumber(todayBillData?.balanceUpiAmount);
  const totalUpiExpense = toNumber(todayBillData?.totalExpense?.UPI);
  const missingUpi = actualUpi - (balanceUpi + totalUpiExpense);
  setMissingUpiAmount(missingUpi);

  // --- WALLET ---
  const actualWallet = toNumber(todayBillData?.walletAmount);
  const balanceWallet = toNumber(todayBillData?.balanceWalletAmount);
  const totalWalletExpense = toNumber(todayBillData?.totalExpense?.WALLET);
  const missingWallet = actualWallet - (balanceWallet + totalWalletExpense);
  setMissingWalletAmount(missingWallet);

  // --- CARD ---
  console.log('cardAmountRecived', cardAmountRecived);

  if (cardAmountRecived) {
    const actualCard = toNumber(todayBillData?.cardAmount);
    const balanceCard = toNumber(todayBillData?.balanceCardAmount);
    const totalCardExpense = toNumber(todayBillData?.totalExpense?.CARD);
    const missingCard = actualCard - (balanceCard + totalCardExpense);
    setMissingCardAmount(missingCard);
  } else {
    setMissingCardAmount(todayBillData?.cardAmount);
  }
};


export const formatDateExpense = (dateString) => {
  if (!dateString) return "N/A";

  // Handle both ISO strings and numeric timestamps
  const d = new Date(dateString);

  // Get UTC date parts to avoid timezone shifting
  const day = String(d.getUTCDate()).padStart(2, "0");
  const month = String(d.getUTCMonth() + 1).padStart(2, "0");
  const year = d.getUTCFullYear();

  return `${day}/${month}/${year}`;
};


export const calculateTotalExpense = (data, setState, payemnts, setMethodData, setRender) => {
  const totals = {
    CASH: 0,
    CARD: 0,
    UPI: 0,
    WALLET: 0
  };


  console.log('data',);


  data.forEach(item => {
    const mode = item.mode?.toUpperCase();
    const amount = Number(item.amount) || 0;

    if (mode && totals.hasOwnProperty(mode)) {
      totals[mode] += amount;
    }
  });


  var oldPayemnts = payemnts
  oldPayemnts.balanceCARD = Number(oldPayemnts.balanceCARD) - Number(totals.CARD)
  oldPayemnts.balanceCASH = Number(oldPayemnts.balanceCASH) - Number(totals.CASH)
  oldPayemnts.balanceUPI = Number(oldPayemnts.balanceUPI) - Number(totals.UPI)
  oldPayemnts.balanceWALLET = Number(oldPayemnts.balanceWALLET) - Number(totals.WALLET)
  setMethodData(oldPayemnts)
  setState(totals);
  setRender(Date.now())
}

export function formatTimestampToDate(timestamp) {
  const date = new Date(timestamp);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}

/**
 * Converts internal file service URL to public-facing URL
 * @param {string} fileUrl - The file URL from the API (e.g., "http://file-service:3004/files/...")
 * @returns {string} - The public URL (e.g., "https://app-api.elevatelifestyle.in/file-service/files/...")
 */
export const convertFileUrlToPublic = (fileUrl) => {
  if (!fileUrl || typeof fileUrl !== 'string') {
    return fileUrl;
  }

  // Convert internal file-service URL to public URL
  if (fileUrl.includes('http://file-service:3004')) {
    return fileUrl.replace('http://file-service:3004', 'https://app-api.elevatelifestyle.in/file-service');
  }

  // If URL already uses http://app-api.elevatelifestyle.in:3004, convert to https with /file-service path
  if (fileUrl.includes('http://app-api.elevatelifestyle.in:3004')) {
    return fileUrl.replace('http://app-api.elevatelifestyle.in:3004', 'https://app-api.elevatelifestyle.in/file-service');
  }

  // If already a public URL, return as is
  return fileUrl;
};